/**
 * @namespace {BX.UI}
 */
export class CounterStyle
{
	static FILLED_EXTRA = '--style-filled-extra';
	static FILLED = '--style-filled';
	static FILLED_INVERTED = '--style-filled-inverted';
	static FILLED_ALERT = '--style-filled-alert';
	static FILLED_ALERT_INVERTED = '--style-filled-alert-inverted';
	static FILLED_WARNING = '--style-filled-warning';
	static FILLED_SUCCESS = '--style-filled-success';
	static FILLED_SUCCESS_INVERTED = '--style-filled-success-inverted';
	static FILLED_NO_ACCENT = '--style-filled-no-accent';
	static FILLED_NO_ACCENT_INVERTED = '--style-filled-no-accent-inverted';
	static TINTED_NO_ACCENT = '--style-tinted-no-accent';
	static OUTLINE_NO_ACCENT = '--style-outline-no-accent';
}
